// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607071504/js/" + chunkId + "." + {"44":"62d6be2d","225":"1f76b9fb","481":"d0d578db","486":"649f5145","770":"46c773a2"}[chunkId] + ".0.33523880608758583.chunk.js";
};